import { HashRouter } from "react-router-dom";
import { AuthGate } from "./components/AuthGate.js";
import { AdminApp } from "./AdminApp.js";
import { CustomerPortal } from "./pages/CustomerPortal.js";
import { supabase } from "./lib/supabaseClient.js";

/**
 * One Pages project, one build, serving both `console.audioswytch.co.uk`
 * (admin) and `account.audioswytch.co.uk` (customer self-service portal) -
 * see DEPLOY.md "Attach all three custom domains". AuthGate resolves the
 * signed-in user's role server-side (GET /api/me) and this component tree
 * is the ONLY place that decides which shell to mount - a customer is never
 * handed a route into AdminApp, and vice versa.
 */
export default function App() {
  return (
    <HashRouter>
      <AuthGate>
        {(me) =>
          me.role === "admin" ? <AdminApp email={me.email} /> : <AccountShell email={me.email} />
        }
      </AuthGate>
    </HashRouter>
  );
}

/** The customer account view is a single page, so it keeps a simple top-bar
 * shell rather than the admin console's sidebar. */
function AccountShell({ email }: { email: string }) {
  return (
    <div className="account-shell">
      <header className="app-header">
        <div className="brand-lockup">
          <img src="/logo.png" alt="" />
          <strong>AudioSw<span className="y">y</span>tch</strong>
          <span className="context">My Account</span>
        </div>
        <span className="spacer" />
        <span className="admin-email">{email}</span>
        <button className="secondary" onClick={() => supabase.auth.signOut()}>Sign out</button>
      </header>
      <CustomerPortal />
    </div>
  );
}
